<template>
    <div class="flex flex-row flex-wrap mb-6" :class="{'pointer-events-none':disabled}">
        <slot></slot>
        <div class="w-full xl:w-1/2 xl:pr-3">
            <slot name="left"></slot>
        </div>
        <div class="w-full xl:w-1/2 xl:pl-3">
            <slot name="right"></slot>
        </div>
    </div>
</template>

<script  setup lang="ts">

defineProps({
    disabled : {
        type: Boolean,
        default: false
    }
});

</script>
